export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/webappstorm-6ca9ee1e43728b11642fd6015bddf48f.png";